import { Button } from '@yes.technology/react-toolkit'
import useMapsURL from './hooks/useMapsURL'

interface DirectionsButtonProps {
  origin: google.maps.LatLngLiteral
  destination: google.maps.LatLngLiteral
}

export const DirectionsButton = ({
  origin,
  destination
}: DirectionsButtonProps) => {
  const { openMaps } = useMapsURL({ origin, destination })

  return (
    <Button variant='secondary' onClick={openMaps}>
      Ver Rota
    </Button>
  )
}
